import { Flex } from 'antd';
import clsx from 'clsx';
import Avatar from 'common/avatar/Avatar';
import IF from 'common/if/IF';
import Tooltip from 'common/antd-tooltip/Tooltip';
import { CircleTickIcon, PersonCircleTickIcon } from 'common/all-icons/custom-icons';
import DisplayDateTime from 'utils/time/display_time';
import styles from './CompletedInfo.module.scss';

const CompletedInfo = ({
  completedBy,
  completedAt,
  byLabel = 'Completed by',
  atLabel = 'Completed at:',
  avatarSize = 16,
  iconSize = 16,
}) => {
  const name = (typeof completedBy === 'string' ? completedBy : completedBy?.name) || '';
  const profilePicture = typeof completedBy === 'string' ? '' : completedBy?.profile_picture || '';
  const formattedDate = DisplayDateTime(completedAt);

  if (!name && !formattedDate) return null;

  return (
    <>
      <IF condition={name}>
        <Tooltip title={byLabel}>
          <Flex align="center" gap={4} className={clsx(styles.pill, styles.byPill)}>
            <PersonCircleTickIcon style={{ color: 'var(--user-main-green)' }} />
            <div style={{ size: avatarSize, flexShrink: 0 }}>
              <Avatar src={profilePicture} name={name} size={avatarSize} />
            </div>
            <span className={clsx('body-11-semibold', styles.name)}>{name}</span>
          </Flex>
        </Tooltip>
      </IF>

      <IF condition={formattedDate}>
        <Tooltip title={atLabel}>
          <Flex align="center" gap={4} className={clsx(styles.pill, styles.atPill)}>
            <span className={styles.icon}>
              <CircleTickIcon width={iconSize} height={iconSize} strokeWidth={2} />
            </span>
            <span className={clsx('body-11-semibold', styles.date)}>{formattedDate}</span>
          </Flex>
        </Tooltip>
      </IF>
    </>
  );
};

export default CompletedInfo;
